import { c as _c } from "react/compiler-runtime";
import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';
import { RouterLink } from 'src/routes/components';
import { paths, newSearchParams } from 'src/routes/paths';
import { useTranslate } from 'src/locales';
import { Iconify } from 'src/components/iconify';
import { useCheckoutContext } from 'src/sections/checkout/context';

// ----------------------------------------------------------------------

export function ShoppingCartButton() {
  const $ = _c(7);
  const {
    currentLang
  } = useTranslate();
  const {
    state: checkoutState,
    activeStep
  } = useCheckoutContext();
  const t0 = `${paths.checkout}${newSearchParams({
    country: currentLang.countryName,
    step: activeStep
  })}`;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "grid",
      cursor: "pointer",
      placeItems: "center",
      color: "text.secondary",
      width: {
        xs: 48,
        md: 40
      },
      height: {
        xs: 48,
        md: 40
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Iconify icon="solar:cart-3-bold-duotone" width={27} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== checkoutState.totalItems) {
    t3 = <Badge color="error" badgeContent={checkoutState.totalItems}>{t2}</Badge>;
    $[2] = checkoutState.totalItems;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t0 || $[5] !== t3) {
    t4 = <Box component={RouterLink} href={t0} sx={t1}>{t3}</Box>;
    $[4] = t0;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}